// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/skins/ui/oxide/skin.min.css
// module id = 895
// module chunks = 0